import { graphql, readInlineData } from 'react-relay';

import { showPricingGuidance as showPricingGuidanceHelper } from 'dibs-pricing-guidance/exports/showPricingGuidance.ts';
import { getHasEnoughSimilarSoldItems } from './getHasEnoughSimilarSoldItems.ts';

import { type getPdpEstimateSimilarSold_viewer$key } from './__generated__/getPdpEstimateSimilarSold_viewer.graphql.ts';
import { type getPdpEstimateSimilarSold_item$key } from './__generated__/getPdpEstimateSimilarSold_item.graphql.ts';

const viewerFragment = graphql`
    fragment getPdpEstimateSimilarSold_viewer on Viewer @inline {
        ...getHasEnoughSimilarSoldItems_viewer
    }
`;

const itemFragment = graphql`
    fragment getPdpEstimateSimilarSold_item on Item @inline {
        ...showPricingGuidance_item
    }
`;

export const getShowPdpEstimateInTab = ({
    viewer: viewerRef,
    item: itemRef,
    currency,
    isPdpEstimateSimilarSoldTestVariant,
}: {
    viewer: getPdpEstimateSimilarSold_viewer$key | null;
    item?: getPdpEstimateSimilarSold_item$key | null;
    currency: string;
    isPdpEstimateSimilarSoldTestVariant: boolean;
}): boolean => {
    const item = readInlineData(itemFragment, itemRef);
    const viewer = readInlineData(viewerFragment, viewerRef);

    const showPricingGuidance = showPricingGuidanceHelper({
        item: item || null,
        currency,
    });
    const hasEnoughSimilarSoldItems = getHasEnoughSimilarSoldItems({ viewer: viewer || null });

    return (
        showPricingGuidance && (!isPdpEstimateSimilarSoldTestVariant || !hasEnoughSimilarSoldItems)
    );
};

export const getShowPdpEstimateSimilarSoldSection = ({
    viewer: viewerRef,
    item: itemRef,
    currency,
}: {
    viewer: getPdpEstimateSimilarSold_viewer$key | null;
    item: getPdpEstimateSimilarSold_item$key | null;
    currency: string;
}): boolean => {
    const item = readInlineData(itemFragment, itemRef);
    const viewer = readInlineData(viewerFragment, viewerRef);

    const showPricingGuidance = showPricingGuidanceHelper({
        item: item || null,
        currency,
    });
    const hasEnoughSimilarSoldItems = getHasEnoughSimilarSoldItems({ viewer: viewer || null });

    return showPricingGuidance && hasEnoughSimilarSoldItems;
};
